import GameRow from '../GameRow/index.jsx';
import styles from './GamesHistory.module.css';
import { HashLink } from 'react-router-hash-link';

export default function GamesHistory({ games, total, lastPage, loading, onLoadMore }) {
    return (
        <section className="container-custom">
            <h2 className={styles.heading}>Ваша история игр</h2>

            <div className={styles.list}>
                {games.length
                    ? games.map((g, i) => (
                        <GameRow key={`${g.bookingId}-${i}`} game={g} gameNumber={total - i} />
                    ))
                    : !loading && (
                    <div className="d-flex justify-content-center align-items-center flex-column">
                        <h3 className={styles.noGames}>
                            Судьба ещё не вписала вашу первую игру в летопись. Исправим?
                        </h3>
                        <HashLink smooth to="/#scheduleSection" className="btn btn-green-filled mt-3">
                            Перейти к расписанию
                        </HashLink>
                    </div>
                )}
            </div>

            {!lastPage && (
                <div className={styles.loadMore}>
                    <button className="btn btn-green-filled" onClick={onLoadMore} disabled={loading}>
                        {loading ? 'Загрузка…' : 'Загрузить ещё'}
                    </button>
                </div>
            )}
        </section>
    );
}
